module.exports = __webpack_public_path__ + "static/media/1.pic.05dc5b84.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/make_over/1.pic.jpg
// module id = 276
// module chunks = 0